<div
  class="bg-light min-vh-100 d-flex align-items-center justify-content-center py-3 notranslate"
>
  <div class="container d-flex justify-content-center">
    <div class="card shadow-lg rounded-4 border-0 consent-card consent-card-compact p-3 p-md-4">
      <div class="card-body p-0">

        <!-- Header -->
        <div class="text-center mb-3">
          <div class="icon-circle mx-auto mb-3">
            <i class="fa fa-user-check" aria-hidden="true"></i>
          </div>
          <h3 class="fw-bold title-text mb-2">Confirma tus datos</h3>
          <p class="text-muted small mb-0">
            Antes de continuar con la revisión o firma del documento, verifica que tu información sea correcta.
          </p>
        </div>

        <!-- Datos del usuario -->
        <div class="data-card mb-3">
          <div class="section-title mb-3">
            <i class="fa fa-id-card text-success-custom"></i>
            <h5 class="fw-bold mb-0">Tus datos</h5>
          </div>

          <div class="row g-3">

            <div class="col-md-6" *ngIf="person?.type === 2">
              <div class="data-item compact">
                <div class="data-label">
                  <i class="fa fa-user me-2 text-success-custom"></i> Razón social
                </div>
                <div class="data-value">{{ person?._more.enterpriseName || 'No disponible' }}</div>
              </div>
            </div>

            <div class="col-md-6" *ngIf="person?.type === 2">
              <div class="data-item compact">
                <div class="data-label">
                  <i class="fa fa-address-card me-2 text-success-custom"></i> RUC
                </div>
                <div class="data-value">{{ person?._more.enterpriseDocumentNumber || 'No disponible' }}</div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="data-item compact">
                <div class="data-label">
                  <i class="fa fa-user me-2 text-success-custom"></i> Nombre completo
                </div>
                <div class="data-value">{{ person?.fullname || 'No disponible' }}</div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="data-item compact">
                <div class="data-label">
                  <i class="fa fa-address-card me-2 text-success-custom"></i> Documento
                </div>
                <div class="data-value">{{ person?.documentNumber || 'No disponible' }}</div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="data-item compact">
                <div class="data-label">
                  <i class="fa fa-phone me-2 text-success-custom"></i> Teléfono
                </div>
                <div class="data-value">{{ person?.cellphone || 'No disponible' }}</div>
              </div>
            </div>

            <div class="col-md-6">
              <div class="data-item compact">
                <div class="data-label">
                  <i class="fa fa-envelope me-2 text-success-custom"></i> Correo electrónico
                </div>
                <div class="data-value">{{ person?.email || 'No disponible' }}</div>
              </div>
            </div>

          </div>
        </div>

        <!-- Nota -->
        <div class="alert consent-alert compact-alert mb-3" role="alert">
          <div class="section-title align-items-start mb-2">
            <i class="fa fa-shield-alt text-success-custom mt-1" aria-hidden="true"></i>
            <div>
              <div class="fw-semibold text-dark mb-1">Confirmación de información</div>
              <small class="text-muted">
                Asegúrate de que tus datos sean correctos antes de continuar con el proceso de revisión o firma digital.
              </small>
            </div>
          </div>
        </div>

        <!-- Confirmación -->
        <form (ngSubmit)="continueProcess()">
          <div class="consent-check compact-check mb-3">
            <label for="acceptConsent" class="consent-check-row">
              <input
                class="custom-checkbox"
                type="checkbox"
                id="acceptConsent"
                (change)="change($event)"
                [checked]="acceptTermsConditions"
                required
              />
              <span class="text-dark fw-medium small-label">
                Confirmo que mis datos son correctos y deseo continuar con el proceso
              </span>
            </label>
          </div>

          <button
            type="submit"
            class="btn btn-success-custom w-100"
            [disabled]="!acceptTermsConditions">
            Continuar
            <i class="fa fa-check-circle ms-2" aria-hidden="true"></i>
          </button>

          <p class="text-center text-muted small mt-2 mb-0">
            Si alguno de tus datos es incorrecto, no continúes y comunícate con soporte.
          </p>
        </form>

      </div>
    </div>
  </div>
</div>
